import { SUI_REGEX } from '@shared/utils/validation/address-validation';
export const validateFESuiAddress = address => {
  const isValidCoinAddress = SUI_REGEX.COIN.test(address);
  const isValidWalletAddress = SUI_REGEX.WALLET.test(address);
  const isShortenedNative = address === '0x2::sui::SUI';
  if (!isValidCoinAddress && !isValidWalletAddress && !isShortenedNative) return false;
  return true;
};